import { ref } from 'vue'

export const logoHome = ref<string | null>(null)
export const logoHomeAlt = ref<string | null>(null)
